import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Col,
  Card,
  CardBody,
  InputGroup,
  Input,
  NavItem,
  NavLink,
  Nav,
  Button,
} from "reactstrap";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import { getRolesAdmin } from "../../slices/admin/thunk";
import Loading from "../../Components/Loading";
import EmployeesTable from "../../Components/Tables/EmployeesTable/EmployeesTable";
import EditEmployeeModal from "../../Components/modals/EmployeesModal/EditEmployeeModal";
import NavTabEmployee from "../../Components/Tabs/NavTabEmployee";
import { getStatusEmployees } from "../../utils/utils";
import SearchBar from "../../Components/SearchBar/SearchBar";
import HeadersRole from "../../Components/Headers/HeadersRole";
import employeesIcon from "../../assets/images/iconsRoles/employeesIcon.svg";
const DashboardAdminEmployees = () => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");

  const [isTerminated, setIsTerminated] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsTerminated(status === "terminated");
      setIsPending(status === "pending");
      setCurrentPage(0);
    }
  };

  const [loading, setLoading] = useState(false);

  const [employees, setEmployees] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [searchDone, setSearchDone] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [countByStatus, setCountByStatus] = useState({
    active: 0,
    terminated: 0,
    pending: 0,
  });

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchRolesAdmin = async () => {
    try {
      const statusEmployees = getStatusEmployees(isTerminated, isPending);
      setLoading(true);
      const response = await dispatch(
        getRolesAdmin({
          role: `employees`,
          status: statusEmployees,
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployees(response.data);
      setTotalEmployees(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      if (response.countByStatus) {
        setCountByStatus({
          active: response.countByStatus.active,
          terminated: response.countByStatus.terminated,
          pending: response.countByStatus.pending,
        });
      }
      setLoading(false);
      setSearchDone(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchRolesAdmin();
  }, [currentPage, isTerminated, isPending, debouncedSearchTerm, dispatch]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState({});

  const handleEditClick = (employee) => {
    setSelectedEmployee(employee);
    setIsEditModalOpen(true);
  };

  const hanldeRefreshTable = () => {
    fetchRolesAdmin();
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      <EditEmployeeModal
        open={isEditModalOpen}
        setOpen={setIsEditModalOpen}
        editUser={selectedEmployee}
        setUser={setSelectedEmployee}
        onRefreshTable={hanldeRefreshTable}
      />
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole role={"Employees"} icon={employeesIcon} svg={true} />
          <Card className="mb-4 pb-3">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1 align-items-center ">
                <div className="col-4 d-flex justify-content-end">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Find employee..."
                    shouldDisplaySearchBar={true}
                  />
                </div>
              </div>

              <Col xl={12}>
                <NavTabEmployee
                  loading={loading}
                  countByStatus={countByStatus}
                  toggleTab={toggleTab}
                  activeTab={activeTab}
                />

                <Col xl={12}>
                  <div className="table-container  position-relative">
                    {loading && <Loading />}
                    <div className="live-preview">
                      <div className="table-responsive">
                        <EmployeesTable
                          searchParam={debouncedSearchTerm}
                          activeTab={activeTab}
                          data={employees}
                          onRefreshTable={hanldeRefreshTable}
                          onEditClick={handleEditClick}
                          shouldShowImportMessage={false}
                          paginationProps={{
                            itemsCount: employees.length,
                            totalPages: totalPages,
                            totalItems: totalEmployees,
                            currentPage: currentPage,
                            onChangePage: handleChangePage,
                          }}
                          isTerminated={isTerminated}
                          searchDone={searchDone}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardAdminEmployees;
